import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateTeam = async (data) => {
  const { orgId, teamId, ...rest } = data
  const url = `v1/orgs/${orgId}/teams/${teamId}`
  return axiosInstance.patch(url, rest)
}

export default updateTeam
